var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.362,
    height: 50.444,
    viewBox: "0 0 138.362 50.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13904",
    "data-name": "Trazado 13904",
    d: "M155.283,814.414a30.331,30.331,0,0,0,7.911-10.858c-.151.218-.313.434-.493.649l-8.106,8.231a3.015,3.015,0,0,1-2.174.878c-.874-.136-1.588-1.117-2.032-1.917a5.564,5.564,0,0,1,1.337-7.1l10.1-10.653c.2.242.393.509.589.787a25.147,25.147,0,0,0-3.153-3.443L149.4,801.413a9.365,9.365,0,0,0-2.149,11.866,10.746,10.746,0,0,0,.8,1.226c.114.1.217.193.335.29C150.542,816.574,153.92,815.58,155.283,814.414Z",
    transform: "translate(-145.981 -790.989)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13906",
    "data-name": "Trazado 13906",
    d: "M215.111,814.414a30.325,30.325,0,0,1-7.911-10.858c.151.218.313.434.492.649l8.106,8.231a3.014,3.014,0,0,0,2.173.878c.875-.136,1.588-1.117,2.033-1.917a5.566,5.566,0,0,0-1.337-7.1l-10.1-10.653c-.195.242-.392.509-.589.787a25.112,25.112,0,0,1,3.153-3.443l9.864,10.424a9.365,9.365,0,0,1,2.149,11.866,10.75,10.75,0,0,1-.8,1.226c-.114.1-.217.193-.334.29C219.852,816.574,216.473,815.58,215.111,814.414Z",
    transform: "translate(-207.2 -790.989)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-145.981 -742.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14697",
    "data-name": "Grupo 14697",
    transform: "translate(146.003 742.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13900",
    "data-name": "Trazado 13900",
    d: "M220.682,801.45l-9.86-10.42c-1.172,1.052-2.941,3.042-2.941,3.042l.022.068c.118-.157.236-.313.352-.458l9.923,10.487.171.159a5.567,5.567,0,0,1,1.346,7.107c-.445.8-1.158,1.782-2.033,1.917a3.007,3.007,0,0,1-2.155-.86l-8.124-8.25a9.014,9.014,0,0,1-.55-.738,30.275,30.275,0,0,0,7.947,10.947c1.362,1.166,4.741,2.16,6.9.381.138-.114.26-.227.392-.34a10.83,10.83,0,0,0,.762-1.176A9.365,9.365,0,0,0,220.682,801.45Z",
    transform: "translate(-176.408 -766.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13901",
    "data-name": "Trazado 13901",
    d: "M184.867,790.144a30.276,30.276,0,0,1-7.947-10.947,6.306,6.306,0,0,1-1.158-4.151,10.464,10.464,0,0,1,2.228-5.214l-.022-.068s1.769-1.99,2.941-3.042l-.014-.014,8.84-9c2.475-2.246,6.1-7.672,2.4-12.428a6.548,6.548,0,0,0-5.163-2.9h-.041c-3.149,0-5.484,2.607-5.942,3.156-.631.662-7.324,7.678-9.7,9.974a1.067,1.067,0,0,1-1.89,0c-2.38-2.3-9.073-9.312-9.7-9.974-.457-.549-2.792-3.156-5.942-3.156h-.041a6.547,6.547,0,0,0-5.163,2.9c-3.7,4.757-.075,10.183,2.4,12.428l8.84,9-.01.01a25.169,25.169,0,0,1,3.153,3.443,10.132,10.132,0,0,1,1.991,4.884,6.333,6.333,0,0,1-1.216,4.24,30.323,30.323,0,0,1-7.911,10.858c-1.362,1.166-4.741,2.16-6.9.381-.118-.1-.221-.193-.334-.29a5.914,5.914,0,0,0,3.881,2.536,5.024,5.024,0,0,0,.731.053,6.81,6.81,0,0,0,4.445-1.95l8.175-8.3.1-.1a10.4,10.4,0,0,0,2.638-7.755c-.444-5.411-5.023-9.583-5.692-10.166l-9.393-9.567-.085-.081c-.045-.04-4.475-4.075-2-7.258a3.17,3.17,0,0,1,2.361-1.5h.026c1.383,0,2.793,1.353,3.216,1.871l.1.12c.294.308,7.124,7.478,9.751,10.028a4.7,4.7,0,0,0,3.088,1.684,3.851,3.851,0,0,0,.437.012,4.05,4.05,0,0,0,.427-.012,4.7,4.7,0,0,0,3.086-1.683c2.625-2.548,9.459-9.721,9.753-10.029l.1-.113a5.091,5.091,0,0,1,3.247-1.878,3.171,3.171,0,0,1,2.361,1.5c2.457,3.155-1.817,7.1-2,7.258l-9.477,9.648c-.668.582-5.248,4.755-5.692,10.166a10.4,10.4,0,0,0,2.638,7.755l8.277,8.413a6.8,6.8,0,0,0,4.438,1.943,5.02,5.02,0,0,0,.731-.053,5.941,5.941,0,0,0,3.918-2.587c-.133.114-.254.226-.392.34C189.608,792.3,186.23,791.311,184.867,790.144Z",
    transform: "translate(-146.495 -742.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13902",
    "data-name": "Trazado 13902",
    d: "M155.328,814.447a30.322,30.322,0,0,0,7.911-10.858c-.152.218-.313.434-.493.649l-8.106,8.232a3.021,3.021,0,0,1-2.174.878c-.875-.136-1.588-1.118-2.033-1.917a5.565,5.565,0,0,1,1.337-7.1l10.1-10.653c.195.243.393.509.589.787a25.169,25.169,0,0,0-3.153-3.443l-9.864,10.424a9.365,9.365,0,0,0-2.149,11.865,10.82,10.82,0,0,0,.8,1.227c.114.1.217.192.334.29C150.587,816.607,153.965,815.614,155.328,814.447Z",
    transform: "translate(-146.026 -766.684)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14699",
    "data-name": "Grupo 14699",
    transform: "translate(145.981 766.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13903",
    "data-name": "Trazado 13903",
    d: "M155.283,814.414a30.331,30.331,0,0,0,7.911-10.858c-.151.218-.313.434-.493.649l-8.106,8.231a3.015,3.015,0,0,1-2.174.878c-.874-.136-1.588-1.117-2.032-1.917a5.564,5.564,0,0,1,1.337-7.1l10.1-10.653c.2.242.393.509.589.787a25.147,25.147,0,0,0-3.153-3.443L149.4,801.413a9.365,9.365,0,0,0-2.149,11.866,10.746,10.746,0,0,0,.8,1.226c.114.1.217.193.335.29C150.542,816.574,153.92,815.58,155.283,814.414Z",
    transform: "translate(-145.981 -790.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14698",
    "data-name": "Grupo 14698",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_548",
    "data-name": "Elipse 548",
    cx: 9.755,
    cy: 10.131,
    rx: 9.755,
    ry: 10.131,
    transform: "translate(7.2 13.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_549",
    "data-name": "Elipse 549",
    cx: 9.755,
    cy: 10.131,
    rx: 9.755,
    ry: 10.131,
    transform: "translate(11.419 -16.785)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14701",
    "data-name": "Grupo 14701",
    transform: "translate(176.613 766.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13905",
    "data-name": "Trazado 13905",
    d: "M215.111,814.414a30.325,30.325,0,0,1-7.911-10.858c.151.218.313.434.492.649l8.106,8.231a3.014,3.014,0,0,0,2.173.878c.875-.136,1.588-1.117,2.033-1.917a5.566,5.566,0,0,0-1.337-7.1l-10.1-10.653c-.195.242-.392.509-.589.787a25.112,25.112,0,0,1,3.153-3.443l9.864,10.424a9.365,9.365,0,0,1,2.149,11.866,10.75,10.75,0,0,1-.8,1.226c-.114.1-.217.193-.334.29C219.852,816.574,216.473,815.58,215.111,814.414Z",
    transform: "translate(-207.2 -790.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14700",
    "data-name": "Grupo 14700",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_550",
    "data-name": "Elipse 550",
    cx: 9.755,
    cy: 10.131,
    rx: 9.755,
    ry: 10.131,
    transform: "translate(-9.497 13.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_551",
    "data-name": "Elipse 551",
    cx: 9.755,
    cy: 10.131,
    rx: 9.755,
    ry: 10.131,
    transform: "translate(-13.717 -16.785)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14703",
    "data-name": "Grupo 14703",
    transform: "translate(204.265 753.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14702",
    "data-name": "Grupo 14702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13907",
    "data-name": "Trazado 13907",
    d: "M285.79,764.406a2.448,2.448,0,0,1,1.725.719,2.262,2.262,0,0,1,.756,1.7,2.362,2.362,0,0,1-.633,1.555L278.066,779.7l-.014,11.339a2.533,2.533,0,0,1-.761,1.963,2.752,2.752,0,0,1-1.937.694,2.81,2.81,0,0,1-1.977-.7,2.532,2.532,0,0,1-.755-1.966l.015-11.339-9.541-11.353a2.361,2.361,0,0,1-.629-1.557,2.261,2.261,0,0,1,.76-1.7,2.448,2.448,0,0,1,1.727-.714,2.3,2.3,0,0,1,1.809.9l8.616,10.41,8.6-10.385A2.3,2.3,0,0,1,285.79,764.406Z",
    transform: "translate(-262.465 -764.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13908",
    "data-name": "Trazado 13908",
    d: "M335.525,791.433a2.013,2.013,0,0,1-.78,1.6,2.7,2.7,0,0,1-1.79.652,2.444,2.444,0,0,1-1.263-.349,2.334,2.334,0,0,1-.925-1.086l-2.519-5.489-14.818-.021-2.533,5.482a2.345,2.345,0,0,1-.927,1.084,2.53,2.53,0,0,1-1.305.346,2.725,2.725,0,0,1-1.767-.657,1.991,1.991,0,0,1-.8-1.6,2.463,2.463,0,0,1,.254-1.064L318,766.07a2.664,2.664,0,0,1,1.159-1.247,3.432,3.432,0,0,1,3.326,0,2.672,2.672,0,0,1,1.156,1.25l11.629,24.291A2.454,2.454,0,0,1,335.525,791.433Zm-20.237-8.789,11.113.016-5.541-12.166Z",
    transform: "translate(-284.267 -764.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13909",
    "data-name": "Trazado 13909",
    d: "M396.612,791.416a2.3,2.3,0,0,1-.781,1.718,2.53,2.53,0,0,1-1.789.734,2.413,2.413,0,0,1-1.851-.9l-8.533-10.327-8.6,10.3a2.333,2.333,0,0,1-1.811.857,2.568,2.568,0,0,1-1.788-.719,2.236,2.236,0,0,1-.777-1.7,2.36,2.36,0,0,1,.634-1.554l9.191-10.876L371.72,768.5a2.166,2.166,0,0,1-.629-1.557,2.263,2.263,0,0,1,.76-1.7,2.5,2.5,0,0,1,1.769-.714,2.421,2.421,0,0,1,1.851.9l8.2,9.877,8.222-9.854a2.3,2.3,0,0,1,1.812-.9,2.569,2.569,0,0,1,1.788.719,2.238,2.238,0,0,1,.777,1.7,2.165,2.165,0,0,1-.634,1.555l-8.812,10.426,9.121,10.9A2.391,2.391,0,0,1,396.612,791.416Z",
    transform: "translate(-316.534 -764.453)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.dee9743c388ceeb5215b8662c41ac5bb.svg";
export { ForwardRef as ReactComponent };